import { render, staticRenderFns } from "./FilterPrices.vue?vue&type=template&id=045b3b1a&scoped=true"
import script from "./FilterPrices.vue?vue&type=script&lang=js"
export * from "./FilterPrices.vue?vue&type=script&lang=js"
import style0 from "./FilterPrices.vue?vue&type=style&index=0&id=045b3b1a&prod&lang=scss&scoped=true"
import style1 from "./FilterPrices.vue?vue&type=style&index=1&id=045b3b1a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045b3b1a",
  null
  
)

export default component.exports